export const pages = [
    { index: 0, name: "overview.md", route: "/overview" },
    { index: 1, name: "education.md", route: "/education" },
    { index: 2, name: "experience.md", route: "/experience" },
    { index: 3, name: "skills.md", route: "/skills" },
    { index: 4, name: "projects.md", route: "/projects" },
    { index: 5, name: "accomplishments.md", route: "/accomplishments" },
    { index: 6, name: "certificates.md", route: "/certificates" },
];
